import { useHistory } from 'react-router-dom';
import { useEffect, useState, useContext, useRef } from 'react';
import { UserContext } from '../../contexts/userContext';
import Cookies from 'js-cookie';
import i18next from 'i18next';
import PingPad from '../items/Pingpad';

import { ReactComponent as Navi1 } from './icons/question-icon.svg';
import { ReactComponent as Navi2 } from './icons/shopping-icon.svg';
import { ReactComponent as Navi3 } from './icons/home-icon.svg';
import { ReactComponent as Back } from './icons/back-icon.svg';
import { ReactComponent as Forward } from './icons/forward-icon.svg';
import { ReactComponent as En } from './icons/english-icon.svg';
import { ReactComponent as Fr } from './icons/french-icon.svg';
import { ReactComponent as Es } from './icons/spanish-icon.svg';
import { ReactComponent as Zh } from './icons/chinese-icon.svg';
import { ReactComponent as User } from './icons/user.svg';

import FAQ from './FAQ/FAQ';
import { languages } from '../../staticData/languages';
import ScanModel from './ScanModel';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';

function NaviBar(props) {
  const [showPingPad, setShowPingPad] = useState(false);
  const clickCountRef = useRef(0);
  const clickTimerRef = useRef(null);

  const { t } = useTranslation();
  const history = useHistory();
  const { stat, setStat } = useContext(UserContext);
  const {
    products,
    cleanUp,
    add,
    cart,
    setShowCart,
    langs,
    setLoading,
    setClientUser,
    clientUser,
    alterquantity,
    decreStock,
    showGoBack,
  } = props;

  const EURO_FLAG = localStorage.getItem('EURO_FLAG') === 'TRUE';
  const machineData = JSON.parse(localStorage.getItem('machine'));
  const faq = machineData?.themeColor?.faq;
  const privacy = machineData?.themeColor?.privacy;
  let machineID = machineData?._id;
  let machineLanguage = machineData?.languages ? machineData?.languages : [];
  const mobile = machineData?.mobile;

  const [currFlag, setCurrFlag] = useState(<En className="navi-icon" />);

  if (machineLanguage) {
    machineLanguage = machineLanguage.map((i) => i.code);
  }
  // console.log('navibar langs', langs);
  const [showScanModel, setShowScanModel] = useState(false);

  const lanOptions = languages.filter((item) => machineLanguage.includes(item.code));

  // machineLanguage.forEach((element) => {
  //   const index = languages.findIndex((e) => e.code === element);
  //   if (index > -1) {
  //     lanOptions.push(languages[index]);
  //   }
  // });

  const home = () => {
    const homepage = localStorage.getItem('homepage');
    history.push(homepage);
  };

  const handleNaviClick = () => {
    // Increment click count
    clickCountRef.current += 1;

    // Clear existing timer
    if (clickTimerRef.current) {
      clearTimeout(clickTimerRef.current);
    }

    // Check if we've reached 5 clicks
    if (clickCountRef.current >= 5) {
      // Trigger PingPad
      setShowPingPad(true);
      clickCountRef.current = 0; // Reset counter
      return; // Don't navigate to home
    }

    // Set timer to reset click count after 2 seconds of inactivity
    clickTimerRef.current = setTimeout(() => {
      clickCountRef.current = 0;
    }, 2000);

    // Navigate to home (your existing functionality)
    home();
  };

  const forward = () => {
    history.goForward();
  };

  const goBack = () => {
    if (!window.location.href.includes('homePage')) {
      history.goBack();
    }
  };

  const [curr, setCurr] = useState([]);
  const [rest, setRest] = useState([]);
  const [show, setShow] = useState(false);
  const [showFAQ, setShowFAQ] = useState(false);

  const setShowTrue = () => {
    show ? setShow(false) : setShow(true);
  };

  const showFAQfunc = () => {
    showFAQ ? setShowFAQ(false) : setShowFAQ(true);
  };

  const clickCart = () => {
    if (cart && cart.length > 0) {
      setShowCart(true);
    } else {
      Swal.fire({
        title: t(`No items in cart.`),
        timer: 2000,
        confirmButtonText: t(`Ok`),
      });
    }
  };

  let component = <div className="empty-icon"></div>;
  //mobile
  if (mobile) {
    component = <User className="navi-icon" onClick={() => setShowScanModel(true)} />;
  }

  useEffect(() => {
    if (showFAQ) {
      console.log('stat', stat);
      stat.faq = stat.faq += 1;
      setStat(stat);
    }
  }, [showFAQ]);

  useEffect(() => {
    const currentLan = Cookies.get('i18next') || languages[0].name;
    const findindex = lanOptions.findIndex((e) => e.code === currentLan);

    if (findindex > -1) {
      let currentop = lanOptions[findindex];

      if (currentop?.code === 'en') {
        console.log('22');
        setCurrFlag(<En className="navi-icon" />);
      }
      if (currentop?.code === 'fr') {
        setCurrFlag(<Fr className="navi-icon" />);
      }
      if (currentop?.code === 'es') {
        setCurrFlag(<Es className="navi-icon" />);
      }
      if (currentop?.code === 'zh') {
        setCurrFlag(<Zh className="navi-icon" />);
      }

      setCurr(currentop);
      const copy = [...lanOptions];

      if (EURO_FLAG) {
        copy.forEach((e) => {
          e.image = e.image2;
        });
      }

      const newRest = copy.splice(findindex, 1);

      setRest(copy);
    }
    // console.log('crr', lanOptions[findindex]);
  }, []);

  const handlepinpad = async (ping) => {
    if (ping === '98948') {
      if (localStorage.getItem('ENABLE_FRIDGE') === 'TRUE') {
        history.push('/techMode/productInventory');
      } else if (localStorage.getItem('ENABLE_LOCKER') === 'TRUE') {
        history.push('/techMode/lockerInventory');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Fridge is not enabled',
          text: 'Please try again.',
          allowOutsideClick: false,
        });
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Incorrect PIN',
        text: 'Please try again.',
        allowOutsideClick: false,
      });
    }
  };

  const selectLanguage = async (index) => {
    rest.push(curr);
    const newCurr = rest.splice(index, 1);
    if (newCurr[0]?.code === 'en') {
      console.log('22');
      stat.language.en = stat.language.en += 1;
      setCurrFlag(<En className="navi-icon" />);
    }
    if (newCurr[0]?.code === 'fr') {
      stat.language.fr = stat.language.fr += 1;
      setCurrFlag(<Fr className="navi-icon" />);
    }
    if (newCurr[0]?.code === 'es') {
      stat.language.es = stat.language.es += 1;
      setCurrFlag(<Es className="navi-icon" />);
    }
    if (newCurr[0]?.code === 'zh') {
      setCurrFlag(<Zh className="navi-icon" />);
    }

    setRest([...rest]);
    setCurr(newCurr[0]);
    setShow(false);

    setStat(stat);
    props.setlangs(newCurr[0].code);
    await i18next.changeLanguage(newCurr[0].code);
  };

  const restLanguage = rest.map((e, i) => {
    if (e.code === 'en') {
      return (
        <div
          className="langauge-resetLan"
          key={i}
          onClick={() => {
            selectLanguage(i);
          }}
        >
          <En className="navi-icon language-other-icon" />
          <div className="language-other-text">{e.name}</div>
        </div>
      );
    }
    if (e.code === 'fr') {
      return (
        <div
          className="langauge-resetLan"
          key={i}
          onClick={() => {
            selectLanguage(i);
          }}
        >
          <Fr className="navi-icon language-other-icon" />
          <div className="language-other-text">{e.name}</div>
        </div>
      );
    }
    if (e.code === 'es') {
      return (
        <div
          className="langauge-resetLan"
          key={i}
          onClick={() => {
            selectLanguage(i);
          }}
        >
          <Es className="navi-icon language-other-icon" />
          <div className="language-other-text">{e.name}</div>
        </div>
      );
    }
    if (e.code === 'zh') {
      return (
        <div
          className="langauge-resetLan"
          key={i}
          onClick={() => {
            selectLanguage(i);
          }}
        >
          <Zh className="navi-icon language-other-icon" />
          <div className="language-other-text">{e.name}</div>
        </div>
      );
    }
  });

  // console.log('languages', currFlag);

  return (
    <div className="navi-bar">
      <PingPad
        show={showPingPad}
        setShow={setShowPingPad}
        center={true}
        close={true}
        run={handlepinpad}
      />
      <FAQ show={showFAQ} setShow={setShowFAQ} langs={langs} />
      <div className="language-div" onClick={setShowTrue}>
        {currFlag}
      </div>
      {show && <div className="langauge-resetLan-container">{restLanguage}</div>}
      {(faq?.length > 0 && faq[0].header?.en) || (privacy?.length > 0 && privacy[0].header?.en) ? (
        <Navi1 className="navi-icon" onClick={showFAQfunc} />
      ) : (
        <div className="empty-icon"></div>
      )}

      <Navi3 className="navi-icon" onClick={handleNaviClick} />
      <div className="home-logo-div">
        <img src={''} className="home-logo" alt="" onClick={home}></img>
      </div>
      {showGoBack ? (
        <Back className="navi-icon" onClick={goBack} />
      ) : (
        <div className="empty-icon"></div>
      )}

      {component}
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <Navi2 className="navi-icon shopping-cart-navi" onClick={clickCart} />
        {cart.length > 0 && (
          <span
            className="cart-item-count"
            style={{
              right: 'calc(50% - 42px)',
            }}
          >
            {cart.reduce((total, item) => total + item.quantity, 0)}
          </span>
        )}
      </div>
      {/* <img src={Navi1} className="navi-icon" alt="" onClick={showFAQfunc}></img> */}
      {mobile && (
        <ScanModel
          products={products}
          cleanUp={cleanUp}
          add={add}
          alterquantity={alterquantity}
          decreStock={decreStock}
          cart={cart}
          machineData={machineData}
          clientUser={clientUser}
          setClientUser={setClientUser}
          show={showScanModel}
          onHide={() => setShowScanModel(false)}
          setLoading={setLoading}
        />
      )}
    </div>
  );
}
export default NaviBar;
